import React, {Component} from "react";
import PropTypes from "prop-types";
import format from "date-fns/format";
import EntryModel from "../models/entry";

export default class Entry extends Component {
    render() {
        let className = this.props.isSelected ? 'list-group-item active' : 'list-group-item';
        let overlapIndicator = this.props.isOverlapping ? <span className="badge badge-danger">Überschneidung</span> : '';

        return (
            <li
                onClick={() => this.props.onClick(this.props.model.id)}
                className={className}
            >
                <strong>{this.props.model.project}: {this.props.model.phase}</strong><small style={{float: 'right'}}>Dauer: <strong>{this.props.model.duration} h</strong></small><br/>
                {this.props.model.activity} {overlapIndicator}<small style={{float: 'right'}}>{format(this.props.model.begin, 'HH:mm')} – {format(this.props.model.end, 'HH:mm')}</small>
            </li>
        )
    }
}

Entry.propTypes = {
    model: PropTypes.instanceOf(EntryModel).isRequired,
    isSelected: PropTypes.bool,
    isOverlapping: PropTypes.bool,
    onClick: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/components/Entry.js